import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useSupplierPublicInfo } from 'services/repositories/orderForms/orderForms';
import { LoadingPage } from 'components/Loading/LoadingPage';
import { SupplierLogo } from 'components/OrderForms/SupplierLogo/SupplierLogo';

import { useRedirectAuthorizedToOrderForm } from '../hooks/useRedirectAuthorizedToOrderForm';
import { OrderFormAuthLayout } from '../components/OrderFormAuthLayout/OrderFormAuthLayout';
import { OrderFormDialog } from '../components/OrderFormDialog/OrderFormDialog';

export function OrderFormUnauthorized() {
  const { t } = useTranslation();
  const params = useParams<{ supplierSlug: string }>();
  const { isLoading: isCheckingForAuthorization } = useRedirectAuthorizedToOrderForm();

  const { data, isLoading: isLoadingSupplierInfo } = useSupplierPublicInfo({
    variables: { supplierSlug: params.supplierSlug },
  });
  const supplierName = data?.data?.name;

  if (isLoadingSupplierInfo || isCheckingForAuthorization) {
    return (
      <OrderFormAuthLayout className="justify-center">
        <LoadingPage />
      </OrderFormAuthLayout>
    );
  }

  return (
    <OrderFormAuthLayout className="pt-36">
      <OrderFormDialog>
        <div className="flex flex-col items-center">
          <SupplierLogo className="mb-6" />
          <h1 className="mb-4 text-2xl leading-8 font-extrabold text-gray-900">
            {t('auth:orderForm.unauthorizedHeading')}
          </h1>
          <p className="text-center text-base leading-6 font-normal text-gray-500">
            {t('auth:orderForm.unauthorizedText', { supplierName })}
          </p>
        </div>
      </OrderFormDialog>
    </OrderFormAuthLayout>
  );
}
